import styled from "styled-components";

export const NoApplications = styled.div`
  z-index: 999999; 
  top: 0; 
  left: 0; 
  height: 100%; 
  overflow: hidden;
  transform: translateX(0); 
  width: 100% !important;
  border: 1px solid #E7E8EA !important;
  border-radius: 10px !important;
  box-shadow: 0 3px 6px rgba(24, 31, 56, 0.15); 
  
  @media (min-width: 1200px) {
      height: 100% !important;
      max-height: 100% !important;
  }
`;